import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';

/** Snackbar duration for authorization messages. */
export const TOAST_DURATION_MS = 6000;

/**
 * SPEC-web-planner-007 AC-18: opens the authorization snackbars. The dedupe state
 * lives in this root service (not in the interceptor) so interceptor instances
 * created by lazy modules share it. A message is suppressed while its snackbar is
 * showing, measured from the snackbar's actual dismissal (afterDismissed), so N
 * parallel failures open one snackbar and the message can show again as soon as
 * it was dismissed.
 */
@Injectable({ providedIn: 'root' })
export class AuthzToastService {
    private readonly _open = new Map<string, MatSnackBarRef<any> | 'pending'>();

    constructor(private _snackBar: MatSnackBar) {}

    show(message: string): void {
        if ( this._open.has(message) )
        {
            return;
        }
        this._open.set(message, 'pending');
        const clear = () => this._open.delete(message);
        try
        {
            const ref = this._snackBar.open(message, 'Dismiss', { duration: TOAST_DURATION_MS });
            this._open.set(message, ref);
            if ( ref && typeof ref.afterDismissed === 'function' )
            {
                ref.afterDismissed().subscribe({ next: clear, complete: clear, error: clear });
            }
            else
            {
                // no ref to observe: fall back to the configured duration
                setTimeout(clear, TOAST_DURATION_MS);
            }
        }
        catch
        {
            clear();
        }
    }
}
